import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBefore = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 10,
			transform: "matrix(-1 0 0 1 20.5 0.0117188)",
			fill: "#EEEEEE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 10.0117,
			r: 2.5,
			fill: "white",
			stroke: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgBefore);
export default ForwardRef;
